import { Outlet, NavLink, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { useEffect } from "react";

import "./index.css";

export function Layout() {
  const location = useLocation();

  useEffect(() => {
    const scroller = document.querySelector(".legalLayoutRoot");
    if (scroller && typeof scroller.scrollTo === "function") {
      scroller.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <Box className="legalLayoutRoot">
      {/* Top Navigation */}
      <Box component="header" className="legalTopNav">
        <Box className="legalTopNavInner">
          <NavLink
            to="/privacy-policy"
            className={({ isActive }) => `legalTopNavLink ${isActive ? "isActive" : ""}`}
          >
            Privacy Policy
          </NavLink>
          <NavLink
            to="/terms-and-conditions"
            className={({ isActive }) => `legalTopNavLink ${isActive ? "isActive" : ""}`}
          >
            Terms of Service
          </NavLink>
        </Box>
      </Box>

      {/* Page Content */}
      <Outlet />
    </Box>
  );
}
